import  React from 'react';
import { removeClass } from '../../../../../util/dom';
import { BgisButtonIcon } from '../../../../icon';

export type BgisSearchBodyProps = {
  children?: React.ReactNode;
};

export const BgisShowDetails  = () => {

  return (
    <div className='bgis-show-details' onClick={() => {removeClass('.bgis-map-area','hide-details')}}>
      <BgisButtonIcon iconName='bgis-icon-chevron-down' onClick={()=>{}}></BgisButtonIcon>
      <span className='bgis-caption bgis-grow'>Details einblenden</span>
    </div>
  );
};
